var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Datepicker',{attrs:{"input-class":"date_int","typeable":true,"language":_vm.en,"value":_vm.dateValue,"format":"yyyy","highlighted":_vm.highlighted,"minimum-view":"year"},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }